export {
  default,
  type LightboxBaseProps,
  type LightboxProps,
  type LightboxButton,
  type LightboxDisableClose,
  type LightboxFirstFocusType,
  type LightboxHeight,
  type LightboxNotDisableClose,
  type LightboxWidth,
} from './Lightbox';
